<article
  *ngIf="!isAuthenticated && hasError"
  class="col-12 pt-1 pb-4 pl-3 pr-4 absolute top-0 w-7 h-1rem mt-1"
>
  <div class="flex flex-wrap justify-content-start align-items-top">
    <img
      id="prompt-logo-center"
      height="50"
      class="agility-logo"
      src="https://d27djv6oelqi3r.cloudfront.net/agility-logo-06.png"
      alt="Agility"
    />
  </div>
</article>

<section
  class="page-layout"
  [class.secure]="isAuthenticated"
  [class.public]="!isAuthenticated"
  [class.error]="hasError"
  [class.banner]="isBannerMessage"
  [ngClass]="{ 'progress-spinner-full-page-opacity': startProgressSpinner }"
>
  <div *ngIf="!isAuthenticated">
    <router-outlet></router-outlet>
    <article
      *ngIf="hasError"
      class="col-12 page-footer pt-1 pb-4 pl-3 pr-4 absolute bottom-0 w-7 h-1rem mb-1"
    >
      <app-footer></app-footer>
    </article>
  </div>
  <div
    *ngIf="isAuthenticated"
    class="app-grid-layout"
    [class.expanded]="isSidebarExpanded$ | async"
  >
    <div *ngIf="startProgressSpinner" class="spinner-container">
      <app-agility-loading-spinner></app-agility-loading-spinner>
    </div>
    <nav class="app-top-nav page-header">
      <div id="messageBanner">
        <p-toast (onClose)="onCloseBannerMessage()" key="toast1"></p-toast>
      </div>
      <div class="px-4">
        <app-header *ngIf="isAuthenticated"></app-header>
      </div>
    </nav>
    <aside class="app-left-nav">
      <app-left-sidebar-menu></app-left-sidebar-menu>
    </aside>
    <div class="app-content" [class.reporting]="isReportingPage">
      <router-outlet></router-outlet>
    </div>
    <footer class="app-footer">
      <app-footer></app-footer>
    </footer>
    <div
      *ngIf="showPermissionsBanner$ | async"
      class="app-permissions-banner"
      [class.expanded]="isSidebarExpanded$ | async"
    >
      <div class="center-content">
        <i class="pi pi-lock text-xs"></i>
        <span>{{ permissionService.banner }}</span>
        <i class="pi pi-lock text-xs"></i>
      </div>
      <i
        class="pi pi-times text-xs close-icon"
        (click)="onClosePermissionsBanner()"
      ></i>
    </div>
  </div>
</section>
<p-toast [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="flex-align">
        <i class="pi p-1" style="font-size: 2rem" [class]="message.icon"></i>
        <div class="flex flex-1 flex-column px-3">
          <h4 class="m-1">{{ message.summary }}</h4>
          <p class="m-1" [innerHTML]="message.detail"></p>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<p-confirmDialog
  [style]="{ width: '29.25rem' }"
  key="inactivityDialog"
  (onHide)="onHideInactivityDialog()"
></p-confirmDialog>
